import { render, staticRenderFns } from "./SkillRef.vue?vue&type=template&id=cef831cc&scoped=true&"
import script from "./SkillRef.vue?vue&type=script&lang=ts&"
export * from "./SkillRef.vue?vue&type=script&lang=ts&"
import style0 from "./SkillRef.vue?vue&type=style&index=0&id=cef831cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef831cc",
  null
  
)

export default component.exports